export default __webpack_public_path__ + "static/public-favorites-1e7636a99c5f2389810b53704a018c9f.webp";